// extracted by mini-css-extract-plugin
export default {"basicInput":"Input_basicInput__F3FXM","searchSelect":"Input_searchSelect__uzk91","searchInput":"Input_searchInput__YIpck","shortInput":"Input_shortInput__JrAR7"};